export const changeLog = [
     {
        version: "2.0.5",
        date: "2026-10-01",
        changes: [
            "New claw controller added for IRL event spaces",
            "Fixed various minor visual issues and colour picker componenet bug",           
            "Improved component flow for The Wave feature",
             "Improved custom font support",
            "Fixed various issues associated with Trivia",
            "Added greater Poll control so data is saved for greater analytical data and can be excluded from leaserbaords if predictive poll"
      ]
    },
     {
        version: "2.0.4",
        date: "2026-09-11",
        changes: [
            "Added grid mode to leaderboards visual settings",
            "Added additional score controls for leaderboards in both customisation and live controls and fixed other minor leaderboard bugs",
            "Fixed layout issue for slider puzzles",
            "Fixed team mode issues for the Wave where progress bar was still visible and team images were missing from component flow",
            "Fixed auto logout issue when ICAST is open in multiple tabs"
      ]
    },
     {
        version: "2.0.3",
        date: "2026-08-13",
        changes: [
            "Added further customisation options to Leaderboards for easier use out of the box",
            "Fixed an issue with the Salesforce ID where if data within Salesforce was missing, it would cause the lookup to fail",
            "Minor visual bug fixes to ICAST"
      ]
    },
    {
        version: "2.0.2",
        date: "2026-08-04",
        changes: [
            "Added ability to connect to both Twitch channels and Amazon Live channels",
            "Modified challenge list icon",
            "Added ability to add a description to templates"
      ]
    },
    {
        version: "2.0.1",
        date: "2026-08-03",
        changes: [
            "Fixed a 409 error when uploading multiple assets to legacy features.",
            "Fixed an issue with the Salesforce feature where the watermark remained visible.",
            "Updated the homepage so super users now only see activity relating to their own campaigns. Previously, super users could see recent activity across every campaign. This was manageable during the early stages, but would become increasingly difficult to use as more campaigns and users are added. All campaigns are still available through the main campaign list.",
            "Fixed an issue where an image filename could appear in the Wave feature's default sound field.",
            "Added the legacy Challenge List feature.",
            "Fixed an issue where fonts were not always displaying correctly.",
            "Improved error handling for missing or broken assets. Previously, if an asset link was broken or failed to load, it could prevent the entire feature from loading and result in an endless spinner.",
            "Added comma-separated streamer lists for Multi-Streamer Mode. This means Player 1 and Player 2 can now be configured for multiple streams without needing to update the settings between each stream.",
            "Fixed a minor issue where feature icons would occasionally not appear on the timeline in Canvas View.",
            "Fixed a small issue relating to uploaded template images.",
            "Added template descriptions on rollover. We will also populate descriptions for the existing templates on the live platform."
        ]
    }
   
]